import "../styles/login.scss";
import { useSelector } from "react-redux";
import actions from "../actions/actions";
import { GuiTextbox } from "../components/global-ui/gui-textbox";
import { useUpdateState } from "../utilities/utilities";
import { Spinner } from "../components/loading-spinner";
import { ToastContainer } from "../components/toast";
import { GuiButton } from "../components/global-ui/gui-button.jsx";

export default function ForgotPassword() {
  let { loggingIn } = useSelector((store) => store.user);
  let [state, update] = useUpdateState({});

  function updateValue(name, value) {
    update({
      [name]: value,
      errors: {
        ...(state.errors || {}),
        [name]: null,
      },
    });
  }

  function sendResetInstructions() {
    if (loggingIn) return;

    let username = (state.username || "").trim();
    let errors = {};

    if (!username) errors.username = "Username is required";

    if (Object.keys(errors).length > 0) {
      update({ errors });
      return;
    }

    update({ errors: null, username });
    actions.passwordRecovery.forgot(username);
  }

  return (
    <div className="login-shell forgot-password-shell">
      <div className="login-brand forgot-password-brand">
        <img src="/lib/images/Vector.svg" alt="High Ground Solutions" />
        <div className="login-brand-caption">High Ground Solutions</div>
      </div>

      <div className="login-screen sign-in-screen forgot-password-screen">
        <div>
          <span
            className="nav-button"
            onClick={() => actions.passwordRecovery.changeScreen("login")}
          >
            <i className="far fa-chevron-left"></i>Back to Login
          </span>
        </div>

        <h2>Forgot Password</h2>
        <div className="text">
          Enter your username and we'll email
          <br />
          you a password reset link.
        </div>

        <GuiTextbox
          label="Username"
          name="username"
          value={state.username}
          onChange={updateValue}
          error={state.errors?.username}
          required
          dataQa="username"
        />

        <GuiButton
          onClick={sendResetInstructions}
          disabled={loggingIn}
          dataQa="reset-instructions"
        >
          {loggingIn ? <Spinner /> : "Send Reset Link"}
        </GuiButton>

        <ToastContainer />
      </div>
    </div>
  );
}
